import { registerPlugin } from '@capacitor/core';
const PdfGenerator = registerPlugin('PdfGenerator', {
    web: () => import('./web').then((m) => new m.PdfGeneratorWeb()),
});
export * from './definitions';
export { PdfGenerator };
//# sourceMappingURL=index.js.map